import type { SVGProps } from 'react'

interface SearchIconProps extends SVGProps<SVGSVGElement> {}

export function SearchIcon(props: SearchIconProps) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_645_1110)">
        <path
          d="M16.2314 14.9352L13.9031 12.6069C14.3834 11.8818 14.6667 11.0156 14.6667 10.0833C14.6667 7.55608 12.6106 5.5 10.0833 5.5C7.55608 5.5 5.5 7.55608 5.5 10.0833C5.5 12.6106 7.55608 14.6667 10.0833 14.6667C11.0156 14.6667 11.8818 14.3834 12.6069 13.9031L14.9352 16.2314C15.2937 16.5898 15.873 16.5898 16.2314 16.2314C16.5898 15.873 16.5898 15.2937 16.2314 14.9352ZM10.0833 12.8333C8.56717 12.8333 7.33333 11.5995 7.33333 10.0833C7.33333 8.56717 8.56717 7.33333 10.0833 7.33333C11.5995 7.33333 12.8333 8.56717 12.8333 10.0833C12.8333 11.5995 11.5995 12.8333 10.0833 12.8333Z"
          fill="currentColor"
        />
        <path
          d="M1.375 10.9999C1.375 5.69331 5.6925 1.3749 11 1.3749C12.9057 1.3749 14.7171 1.93131 16.2543 2.93965L14.8683 4.32656C14.4357 4.75739 14.7409 5.4999 15.3542 5.4999H19.4792C19.8587 5.4999 20.1667 5.1919 20.1667 4.8124V0.687395C20.1667 0.0778117 19.4278 -0.232938 18.9933 0.201562L17.2388 1.95606C15.4321 0.701145 13.277 -0.000104943 11 -0.000104943C4.93442 -0.000104943 0 4.93431 0 10.9999C0 12.0751 0.158583 13.144 0.47025 14.1771C0.579333 14.5391 0.95975 14.7463 1.32733 14.6372C1.69033 14.5272 1.89658 14.1441 1.78658 13.7801C1.51342 12.8754 1.375 11.9404 1.375 10.9999Z"
          fill="currentColor"
        />
        <path
          d="M21.5295 7.82283C21.4195 7.45892 21.039 7.25175 20.6724 7.36267C20.3094 7.47267 20.1031 7.85583 20.2131 8.21975C20.4863 9.1245 20.6247 10.0595 20.6247 11C20.6247 16.3066 16.3072 20.625 10.9997 20.625C9.09763 20.625 7.28904 20.0713 5.75454 19.0667L7.13413 17.6715C7.56313 17.237 7.25513 16.5 6.64554 16.5H2.52054C2.33721 16.5 2.16029 16.5733 2.03196 16.7044C1.90363 16.8355 1.83121 17.0115 1.83304 17.1948L1.87888 21.3198C1.88438 21.9303 2.62963 22.2273 3.05496 21.7956L4.77646 20.0548C6.57954 21.3033 8.72913 22 10.9997 22C17.0653 22 21.9997 17.0656 21.9997 11C21.9997 9.92475 21.8411 8.85592 21.5295 7.82283Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_645_1110">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
